/**
 * UUIDv7 identifiers: time-ordered, generated on any device, unique without coordination.
 * Every ledger event, transaction, product, and register id is one of these (PRD §10.5).
 */
export const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

let lastMs = 0;
let counter = 0;

export function uuidv7(now: number = Date.now()): string {
  if (now <= lastMs) {
    counter = (counter + 1) & 0x0fff;
    if (counter === 0) lastMs += 1;
  } else {
    lastMs = now;
    counter = Math.floor(Math.random() * 0x0800);
  }
  const ms = lastMs;
  const b = new Uint8Array(16);
  b[0] = Math.floor(ms / 2 ** 40) & 0xff;
  b[1] = Math.floor(ms / 2 ** 32) & 0xff;
  b[2] = Math.floor(ms / 2 ** 24) & 0xff;
  b[3] = Math.floor(ms / 2 ** 16) & 0xff;
  b[4] = Math.floor(ms / 2 ** 8) & 0xff;
  b[5] = ms & 0xff;
  b[6] = 0x70 | ((counter >> 8) & 0x0f);
  b[7] = counter & 0xff;
  const rand = crypto.getRandomValues(new Uint8Array(8));
  b[8] = 0x80 | ((rand[0] ?? 0) & 0x3f);
  for (let i = 1; i < 8; i++) b[8 + i] = rand[i] ?? 0;
  const hex = Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function isUuid(value: unknown): value is string {
  return typeof value === "string" && UUID_RE.test(value);
}

/** Millisecond timestamp encoded in a UUIDv7. Returns null for other versions. */
export function uuidv7Timestamp(id: string): number | null {
  if (!UUID_RE.test(id) || id[14] !== "7") return null;
  const hex = id.replace(/-/g, "").slice(0, 12);
  return parseInt(hex, 16);
}
